import React, { useContext } from 'react'
import { useObserver } from 'mobx-react-lite'

import { AppStoreContext } from '../../../contexts'
import CustomSuccessSnackbar from './SuccessSnackbar'

export default function CustomSnackbars(props) {
  /**
  |--------------------------------------------------
  | Context
  |--------------------------------------------------
  */
  const appStore = useContext(AppStoreContext)

  /**
  |--------------------------------------------------
  | Render
  |--------------------------------------------------
  */
  return useObserver(() => {
    const { isOpenSnackbar, snackbarType, snackbarMessage, setIsOpenSnackbar } = appStore

    return (
      <>
        {snackbarType === 'success' && (
          <CustomSuccessSnackbar
            open={isOpenSnackbar}
            message={snackbarMessage}
            onClose={() => setIsOpenSnackbar(false)}
          />
        )}
      </>
    )
  })
}
